<form (ngSubmit)="send()">
  <mat-form-field appearance="fill" floatLabel="always">
    <mat-label>Сумма</mat-label>
    <input matInput type="number" class="right-align" placeholder="0" [formControl]="sum" />
    <span matPrefix>₴&nbsp;</span>
    <span matSuffix>.00</span>
  </mat-form-field>
  <button mat-flat-button color="primary" type="submit" [disabled]="sendLinkLoading">
    {{ sendLinkLoading ? 'Загрузка' : 'Отправить счет для оплаты' }}
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="copyLinkToPay()"
    type="button"
    [disabled]="copyLinkLoading"
  >
    {{ copyLinkLoading ? 'Загрузка' : 'Скопировать ссылку' }}
  </button>
</form>
